export const LOCATIONS_FETCH       = Symbol.for('locations.list');